// Soll-/Ist-Kurve für ein kumulatives Kriterium: geplanter Verlauf (gestrichelt,
// linear oder exponentiell) plus die tatsächlich gemeldeten Ist-Werte (Punkte +
// Linie). Reine Visualisierung, keine Interaktion.
import { monthList, metricMonthTarget, metricMonthValue } from './lib/goals.js';

function GoalMetricCurve({ metric, goal, progressRows, color = 'var(--accent)' }) {
  if (!metric || metric.type !== 'cumulative') return null;
  const months = monthList(goal?.start_date, goal?.target_date);
  if (months.length < 2) return null;

  const W = 320, H = 110, padX = 8, padTop = 10, padBot = 12;
  const n = months.length;
  const start = Number(metric.start_value) || 0;
  const target = Number(metric.target_value) || 0;

  const actuals = months.map(mk => metricMonthValue(progressRows, mk));
  const known = actuals.filter(v => v != null);
  const hi = Math.max(target, start, ...known, 1);
  const lo = Math.min(start, ...known, 0);

  const x = (i) => padX + (i / (n - 1)) * (W - 2 * padX);
  const y = (v) => H - padBot - ((v - lo) / ((hi - lo) || 1)) * (H - padTop - padBot);

  const plannedPath = months
    .map((mk, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)} ${y(metricMonthTarget(metric, goal, mk)).toFixed(1)}`)
    .join(' ');

  const actualPts = months
    .map((mk, i) => actuals[i] != null ? { x: x(i), y: y(actuals[i]) } : null)
    .filter(Boolean);
  const actualPath = actualPts.map((p, i) => `${i ? 'L' : 'M'}${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(' ');

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ display: 'block', height: 'auto' }}>
      {/* baseline */}
      <line x1={padX} y1={H - padBot} x2={W - padX} y2={H - padBot} stroke="var(--stroke)" strokeWidth="1"/>
      {/* planned target line (dashed) */}
      <path d={plannedPath} fill="none" stroke="var(--ink-4)" strokeWidth="1.5" strokeDasharray="4 4"/>
      {/* actual line + dots */}
      {actualPts.length > 1 && <path d={actualPath} fill="none" stroke={color} strokeWidth="2"/>}
      {actualPts.map((p, i) => <circle key={i} cx={p.x} cy={p.y} r="3" fill={color}/>)}
    </svg>
  );
}

export { GoalMetricCurve };
